import { useCallback, useState } from 'react'
import { useQuery } from 'react-query'
import { ONE_HOUR_IN_MS } from 'src/constants/time'
import { Company, Expedient } from 'src/interfaces'
import * as ExpedientsService from 'src/services/ExpedientsService'
import ExpedientsTableView from './ExpedientsTableView'

type Props = {
  company: Company
  classificationName: string | undefined
  expireDate: string | undefined
  onSelectExpedient: (expedient: Expedient) => void
  setClassificationName: (classifiedName: string) => void
  setExpireDate: (expireDate: string) => void
  selectedExpedient: Expedient | null
}

type State = {
  pageIndex: number
  pageSize: number
  searchedText: string
}

function ExpedientsTable({
  company,
  classificationName,
  onSelectExpedient,
  setClassificationName,
  setExpireDate,
  expireDate,
  selectedExpedient
}: Props): JSX.Element {
  const [paginationOptions, setPaginationOptions] = useState<State>({
    pageIndex: 0,
    pageSize: 10,
    searchedText: ''
  })

  const queryKey = [
    'expedients',
    company.idCompany,
    paginationOptions.pageIndex,
    paginationOptions.pageSize,
    paginationOptions.searchedText
  ]
  const expedientsQuery = useQuery(
    [queryKey],
    () =>
      ExpedientsService.getExpedients(
        company.idCompany,
        paginationOptions.searchedText,
        paginationOptions.pageSize,
        paginationOptions.pageIndex + 1
      ),
    {
      staleTime: ONE_HOUR_IN_MS
    }
  )

  const onChangePaginationOptions = useCallback(function(value) {
    setPaginationOptions(value)
  }, [])

  return (
    <ExpedientsTableView
      onSelectExpedient={onSelectExpedient}
      setClassificationName={setClassificationName}
      setExpireDate={setExpireDate}
      expedientsQuery={expedientsQuery}
      selectedExpedient={selectedExpedient}
      onChangePaginationOptions={onChangePaginationOptions}
      pageSize={paginationOptions.pageSize}
      classificationName={classificationName}
      expireDate={expireDate}
    />
  )
}

export default ExpedientsTable
